/**
 * Quantities that must not be interchanged.
 *
 * Mixing a ratio with a pixel value is the likeliest bug in this codebase,
 * because every dimension here is derived from a ratio of the source frame.
 * Branding them turns that mistake into a type error instead of a misplaced box.
 */

declare const brand: unique symbol;
type Brand<T, B extends string> = T & { readonly [brand]: B };

/** A fraction of a source frame dimension, or of Fontsize. */
export type Ratio = Brand<number, "Ratio">;
/** A length in source-frame pixels. */
export type Pixels = Brand<number, "Pixels">;
export type Milliseconds = Brand<number, "Milliseconds">;

export const ratio = (value: number): Ratio => value as Ratio;
export const px = (value: number): Pixels => value as Pixels;
export const ms = (value: number): Milliseconds => value as Milliseconds;
